import type { WidgetRegistryEntry } from './types';

import giteaManifest from './gitea-recent-commits/manifest.json';
import GiteaRecentCommits from './gitea-recent-commits/Widget';
import reviewManifest from './gitea-review-notifications/manifest.json';
import GiteaReviewNotifications from './gitea-review-notifications/Widget';
import opManifest from './openproject-work-packages/manifest.json';
import OpenProjectWorkPackages from './openproject-work-packages/Widget';
import deliveryManifest from './openproject-delivery-breakdown/manifest.json';
import OpenProjectDeliveryBreakdown from './openproject-delivery-breakdown/Widget';
import bugsManifest from './openproject-bugs-issues/manifest.json';
import OpenProjectBugsIssues from './openproject-bugs-issues/Widget';
import ncManifest from './nextcloud-recent-files/manifest.json';
import NextcloudRecentFiles from './nextcloud-recent-files/Widget';
import wpManifest from './woodpecker-build-status/manifest.json';
import WoodpeckerBuildStatus from './woodpecker-build-status/Widget';
import aiManifest from './ai-story-writer/manifest.json';
import AIStoryWriter from './ai-story-writer/Widget';
import AIStoryWriterSettings from './ai-story-writer/Settings';

const WIDGET_REGISTRY: WidgetRegistryEntry[] = [
	{ manifest: giteaManifest as unknown as WidgetRegistryEntry['manifest'], Component: GiteaRecentCommits },
	{
		manifest: reviewManifest as unknown as WidgetRegistryEntry['manifest'],
		Component: GiteaReviewNotifications,
	},
	{ manifest: opManifest as unknown as WidgetRegistryEntry['manifest'], Component: OpenProjectWorkPackages },
	{
		manifest: deliveryManifest as unknown as WidgetRegistryEntry['manifest'],
		Component: OpenProjectDeliveryBreakdown,
	},
	{
		manifest: bugsManifest as unknown as WidgetRegistryEntry['manifest'],
		Component: OpenProjectBugsIssues,
	},
	{ manifest: ncManifest as unknown as WidgetRegistryEntry['manifest'], Component: NextcloudRecentFiles },
	{ manifest: wpManifest as unknown as WidgetRegistryEntry['manifest'], Component: WoodpeckerBuildStatus },
	{
		manifest: { ...(aiManifest as unknown as WidgetRegistryEntry['manifest']), configurable: true },
		Component: AIStoryWriter,
		SettingsComponent: AIStoryWriterSettings,
	},
];

export default WIDGET_REGISTRY;

export function getWidget(widgetId: string): WidgetRegistryEntry | undefined {
	return WIDGET_REGISTRY.find((w) => w.manifest.id === widgetId);
}

export function getWidgetsForContext(
	contextType: 'ecosystem' | 'project',
	_ecosystemId: string,
	ecosystemServices?: string[]
): WidgetRegistryEntry[] {
	const services = new Set<string>(
		ecosystemServices ?? ['gitea', 'nextcloud', 'woodpecker', 'openproject']
	);
	return WIDGET_REGISTRY.filter(
		(w) =>
			w.manifest.contexts.includes(contextType) &&
			w.manifest.services.some((s) => services.has(s))
	);
}
